/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IPowerReviews contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum displayType {
    questionsReviews = 'questionsReviews',
    writeReview = 'writeReview',
    reviewSnippet = 'reviewSnippet'
}

export interface IPowerReviewsConfig extends Msdyn365.IModuleConfig {
    displayType: displayType;
    url: string;
    apiKey: string;
    locale: string;
    merchantId: string;
    groupId: string;
    siteId: string;
    reviewPage: IReviewPageData;
    reviewSnippetLink?: IReviewSnippetLinkData;
    className?: string;
}

export interface IReviewPageData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IReviewSnippetLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IPowerReviewsProps<T> extends Msdyn365.IModule<T> {
    config: IPowerReviewsConfig;
}
